import { h, render, Component } from 'preact';
import MarkersList from './markers-list/markers-list';
import './markers-tools-control.scss';
import TimeExpiration from './time-expiration/time-expiration';
import FollowObject from './follow-object/follow-object';

export default class MarkersToolsControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            markers: [],
            fromDate: null,
            toDate: null,
            allowTrack: false,
            loading: true
        };
    }

    componentDidMount() {
        this.props.radar.getMarkersRequest()
        .then((data) => {
            if (!!data) {
                const marker = data.objectsList[0];
                this.setState({ 
                    markers: [...data.objectsList],
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    allowTrack: data.allowTrack,
                    loading: false
                });
                this.props.radar.setCurrentMarker(marker);
                let isToFollow = this.props.radar.isFollowObject();
                this.props.radar.setToFollow(true);
                this.props.radar.followObject();
                this.props.radar.setToFollow(isToFollow);                
            }
        });
    }   
    
    render (props, state) {
        return (
            <div class="markers-tools-control-wrapper" style={this.props.position?this.props.position:''}>
                {
                    !this.state.loading &&                
                    <div class="markers-tools-control-top">
                        <TimeExpiration 
                            radar={props.radar}
                            fromDate={state.fromDate}
                            toDate={state.toDate}
                        />
                        <FollowObject radar={props.radar}/>
                    </div>
                }
                {
                    !this.state.loading &&                    
                    <MarkersList
                        markersService={props.markersService}
                        routesService={props.routesService}
                        radar={props.radar}
                        updateTimeoutValue={props.updateTimeoutValue}
                        markers={state.markers}
                        allowTrack={state.allowTrack}
                    />
                }
                {
                    this.state.loading &&
                    <div class="markers-list-loader-wrapper">
                        <div class="markers-tools-control-loader"></div>
                    </div>
                }
            </div>
        );
    }
}